<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <div v-permissions="'company:query'" class="main" v-show="web == 'main'">
      <div class="title">公司管理</div>
      <el-form class="search-form" ref="form" :model="searchForm" label-width="80px" @submit.native.prevent="false">
        <el-row>
          <el-col :xs="24" :sm="8">
            <el-form-item label="公司名称" prop="name">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入"
                clearable
                @keyup.enter.native="search(1)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="是否在免费期内" prop="isFreePeriod" label-width="120px">
              <el-select v-model="searchForm.isFreePeriod" placeholder="请选择" clearable @change="search(1)">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="服务到期天数" class="roleName" label-width="120px">
              <el-select
                v-model="searchForm.lastFewDays"
                size="small"
                placeholder="请选择"
                clearable
                @change="search(1)"
              >
                <el-option label="不限" value=""></el-option>
                <el-option
                  :label="item.code + '天'"
                  :value="item.code"
                  v-for="(item, index) in cycle2"
                  :key="'4-' + index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="16">
            <el-form-item class="show-pc roleName" label="区域" prop="qy">
              <el-cascader
                class="width-100"
                v-model="searchForm.qy"
                placeholder="请选择区域"
                :options="options"
                filterable
                @change="searchQyChange"
                clearable
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="销售经理" prop="accountManagerId" label-width="120px">
              <el-select v-model="searchForm.salesManagerId" placeholder="请选择" @change="salesManagerChange">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="btn">
          <el-button v-permissions="'company:query'" type="primary" size="small" class="search" @click="search"
            >查询
          </el-button>
          <el-button v-permissions="'company:add'" size="small" class="add" icon="el-icon-plus" @click="add"
            >新增公司
          </el-button>
          <el-button v-permissions="'company:query'" type="warning" plain size="small" class="search" @click="reset"
            >清空筛选项
          </el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" height="74vh" style="width: 100%">
        <el-table-column label="公司名称">
          <template slot-scope="scope">
            <span>{{ scope.row.aosCompany.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区域">
          <template slot-scope="scope">
            <span>{{
              scope.row.aosCompany.area1 + '/' + scope.row.aosCompany.area2 + '/' + scope.row.aosCompany.area3
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="200">
          <template slot-scope="scope">
            <span>{{
              (scope.row.aosCompany.startBillingPeriod && scope.row.aosCompany.startBillingPeriod.substring(0, 10)) +
                ' ~ ' +
                (scope.row.aosCompany.endBillingPeriod && scope.row.aosCompany.endBillingPeriod.substring(0, 10))
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售经理">
          <template slot-scope="scope">
            <span>{{ scope.row.aosCompany.salesManagerName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-permissions="'company:update'"
              size="mini"
              type="primary"
              plain
              @click="handleEdit(scope.$index, scope.row.aosCompany)"
              >编辑
            </el-button>
            <el-button
              v-permissions="'company:delete'"
              size="mini"
              type="danger"
              plain
              @click="handleDelete(scope.$index, scope.row.aosCompany)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[100, 200, 500, 1000, 2000]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import cityData from '../../utils/Data'
// import selfTitle from '../components/Title'
export default {
  name: 'Company',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['公司管理'],
      web: 'main',
      searchForm: {
        name: '', // 公司名称
        qy: [],
        area1: '', // 区域1
        area2: '', // 区域2
        area3: '', // 区域3
        isFreePeriod: '', // 是否在免费期内
        lastFewDays: '', // 服务到期天数，传30，60，90，180，360，就是查30天内，60天内，90天内到期的客户
        salesManagerId: '', // 销售员工id
        page: 1, // 当前页数
        limit: 50 // 每页条数
      },
      cycle2: [
        { code: 0, name: '到期' },
        { code: '30', name: '30天' },
        { code: '60', name: '60天' },
        { code: '90', name: '90天' },
        { code: '120', name: '120天' },
        { code: '180', name: '180天' }
        // { code: '360', name: '360天' }
      ],
      options: cityData, // 全国省市
      tableData: [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      persons: [], // 所有公司员工
      rules: {
        workNumber: [{ required: true, message: '请输入公司姓名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        phone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(rule.msg)
              } else {
                const reg = /^[1][3-9][0-9]{9}$/
                reg.test(value) ? callback() : callback('请输入正确的手机号码')
              }
            },
            msg: '请输入手机号码',
            trigger: 'blur'
          }
        ],
        role: [{ required: true, message: '请选择权限', trigger: 'change' }]
      }
    }
  },
  methods: {
    reset() {
      this.searchForm = {
        name: '', // 公司名称
        qy: [],
        area1: '', // 区域1
        area2: '', // 区域2
        area3: '', // 区域3
        isFreePeriod: '', // 是否在免费期内
        lastFewDays: '', // 服务到期天数，传30，60，90，180，360，就是查30天内，60天内，90天内到期的客户
        salesManagerId: '', // 销售员工id
        page: 1, // 当前页数
        limit: 50 // 每页条数
      }
      this.search(1)
    },
    // 区域更改
    searchQyChange(val) {
      if (val) {
        this.searchForm.area1 = val[0]
        this.searchForm.area2 = val[1]
        this.searchForm.area3 = val[2]
      }
      this.search(1)
    },
    // 客户经理选择变化
    salesManagerChange(val) {
      for (let i = 0; i < this.persons.length; i++) {
        if (this.persons[i].id === val) {
          this.searchForm.salesManagerName = this.persons[i].name
        }
      }
      console.log(this.searchForm)
      this.search(1)
    },
    titleClick(item, index) {
      console.log(item, index)
      if (item === '公司管理') {
        this.web = 'main'
        this.titles = ['公司管理'] // 导航菜单
      }
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    search() {
      // 查询
      this.page = 1
      this.queryCompanyList()
    },
    // 客户新增点击
    add() {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          id: null,
          webState: 'add'
        }
      })
    },
    // 客户编辑
    handleEdit(index, row) {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          id: row.id,
          webState: 'edit'
        }
      })
    },
    // 客户详情
    handleDetail(index, row) {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          id: row.id,
          webState: 'detail'
        }
      })
    },
    handleDelete(index, row) {
      // 删除
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此公司吗?' },
        () => {
          const param = {
            id: row.id
          }
          this.$get('/company/delete', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消注销')
        }
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    queryCompanyList() {
      // 查询公司列表
      const param = {
        name: this.searchForm.name, // 公司名称
        area1: this.searchForm.area1, // 区域1
        area2: this.searchForm.area2, // 区域2
        area3: this.searchForm.area3, // 区域3
        isFreePeriod: this.searchForm.isFreePeriod, // 是否在免费期内
        lastFewDays: this.searchForm.lastFewDays, // 服务到期天数，传30，60，90，180，360，就是查30天内，60天内，90天内到期的客户
        salesManagerId: this.searchForm.salesManagerId, // 销售员工id
        page: this.searchForm.page, // 当前页数
        limit: this.searchForm.limit // 每页条数
      }
      this.$post('/company/query', param).then(
        result => {
          // console.log(result)
          if (result.status === 200) {
            this.total = result.count
            this.tableData = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.message, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    queryAllRole() {
      // 查询公司列表
      const param = {
        page: 1,
        limit: 1000
      }
      this.$post('/role/queryAllRole', param).then(
        result => {
          if (result.status === 200) {
            this.menus = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    } else {
      return this.$root.$children[0].vueAlert({ message: '未获取到公司信息', type: 'warning' })
    }
    this.queryCompanyList()
    this.queryUserIdName()
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped></style>
